var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSigndeskLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LOGO",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.633,
    height: 16.593,
    viewBox: "0 0 78.633 16.593",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M207.455,242.363a2,2,0,0,0,2.054,1.4c1.166,0,1.876-.585,1.876-1.358,0-.7-.582-1.13-1.3-1.4l-1.332-.456c-1.75-.572-2.054-1.6-2.054-2.375a2.6,2.6,0,0,1,2.851-2.444,2.745,2.745,0,0,1,2.9,2.107l-1.142.342a1.634,1.634,0,0,0-1.765-1.308c-.849,0-1.572.47-1.572,1.283,0,.38.114.876,1.154,1.27l1.344.508a2.674,2.674,0,0,1,2.155,2.387c0,1.574-1.242,2.58-3.093,2.58a3.15,3.15,0,0,1-3.271-2.223Z",
    transform: "translate(-187.298 -232.925)",
    fill: "#404751"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M268.589,234a.855.855,0,0,1,.862.864.846.846,0,0,1-.862.851.835.835,0,0,1-.85-.851.846.846,0,0,1,.85-.864m.621,2.908h-1.232v6.348h1.23Z",
    transform: "translate(-240.43 -231.43)",
    fill: "#404751"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M301.092,260.816c0,2.109-1.572,3.035-3.31,3.035a3.95,3.95,0,0,1-2.716-.914l.494-.965a3.272,3.272,0,0,0,2.219.8,1.91,1.91,0,0,0,2.08-2.069v-.85a2.661,2.661,0,0,1-2.295,1.155,3.318,3.318,0,0,1,0-6.627,2.661,2.661,0,0,1,2.295,1.155v-1.017h1.23Zm-3.373-5.344a2.228,2.228,0,0,0,0,4.444,2.223,2.223,0,0,0,0-4.444",
    transform: "translate(-263.488 -249.043)",
    fill: "#404751"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M367.165,257.287c0-1.346-.621-1.815-1.293-1.815s-2.037.444-2.037,2.444v2.946H362.6V254.52h1.23v1.27a2.064,2.064,0,0,1,2.13-1.409c1.37,0,2.435.864,2.435,2.907v3.581h-1.23Z",
    transform: "translate(-322.411 -249.043)",
    fill: "#404751"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M428.467,245.588H425.64V236.7h2.827a4.446,4.446,0,1,1,0,8.888m0-7.847h-1.556v6.805h1.56a3.405,3.405,0,0,0,0-6.805",
    transform: "translate(-376.891 -233.763)",
    fill: "#404751"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M499.132,259.826a3.568,3.568,0,0,1-2.777,1.181,3.319,3.319,0,1,1-.164-6.627,3.132,3.132,0,0,1,3.233,3.427H494.01a2.121,2.121,0,0,0,2.358,2.109,3.078,3.078,0,0,0,2.079-.8Zm-5.008-2.971h4.031a1.859,1.859,0,0,0-1.939-1.4,2.107,2.107,0,0,0-2.092,1.4",
    transform: "translate(-434.915 -249.043)",
    fill: "#404751"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M555.558,256.106a.948.948,0,0,0-.99-.7.846.846,0,0,0-.938.815c0,.42.382.635.762.762l.912.305a1.821,1.821,0,0,1,1.522,1.79,2.036,2.036,0,0,1-2.283,1.9,2.385,2.385,0,0,1-2.444-1.663l1.086-.272a1.393,1.393,0,0,0,1.369.877c.646,0,1.086-.369,1.086-.864,0-.432-.354-.648-.8-.8l-.844-.291c-1.014-.306-1.559-.851-1.559-1.727a1.918,1.918,0,0,1,2.091-1.891,2.045,2.045,0,0,1,2.118,1.51Z",
    transform: "translate(-486.181 -249.017)",
    fill: "#404751"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M605.721,237.382h1.37v.136l-2.32,2.781,1.078,1.644c.368.521.543.851,1.116.851a1.364,1.364,0,0,0,.824-.242l.418.826a1.89,1.89,0,0,1-1.382.5,2.3,2.3,0,0,1-2-1.346l-1.28-2.057v3.259h-1.23v-9.18h1.23v5.492Z",
    transform: "translate(-529.573 -231.905)",
    fill: "#404751"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M187.6,263.8a8.372,8.372,0,0,1,.157,1.242,8.372,8.372,0,0,0-.157-1.242",
    transform: "translate(-171.172 -257.184)",
    fill: "#f37c60"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M187.757,279.27a8.386,8.386,0,0,1-.158,1.245,8.386,8.386,0,0,0,.158-1.245",
    transform: "translate(-171.172 -270.553)",
    fill: "#f37c60"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M83.195,225.1a8.282,8.282,0,0,0-5.894-7.517l2.653,7.924s-4.023,2.4-4.527,5.666H75.1V225.1a1.206,1.206,0,0,0,1.086-1.164,1.268,1.268,0,0,0-2.53,0,1.207,1.207,0,0,0,1.086,1.164v6.08H74.4c-.5-3.259-4.524-5.666-4.524-5.666l2.679-7.939a8.3,8.3,0,1,0,10.475,9.628,8.388,8.388,0,0,0,.157-1.245c0-.136.011-.284.011-.428s-.007-.285-.011-.43",
    transform: "translate(-66.609 -217.239)",
    fill: "#71a350"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M95.239,229.009h.33v-6.073a1.207,1.207,0,0,1-1.086-1.164,1.268,1.268,0,0,1,2.53,0,1.206,1.206,0,0,1-1.086,1.164v6.08h.329c.5-3.259,4.525-5.666,4.525-5.666l-2.653-7.931a8.307,8.307,0,0,0-4.737-.008l-2.669,7.932s4.024,2.4,4.524,5.666",
    transform: "translate(-87.446 -215.07)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigndeskLogo);
export default __webpack_public_path__ + "static/media/signdesk_logo.1e87cec30c3573827ed9f57887c51d50.svg";
export { ForwardRef as ReactComponent };